import { render } from "./Imagenes.vue?vue&type=template&id=26fa1380"
import script from "./Imagenes.vue?vue&type=script&lang=js"
export * from "./Imagenes.vue?vue&type=script&lang=js"

import "./Imagenes.vue?vue&type=style&index=0&id=26fa1380&lang=css"
script.render = render

export default script